import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import { createBrowserHistory } from 'history';
// import { Route } from 'react-router-dom';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import {  getWebInstrumentations, initializeFaro } from '@grafana/faro-react';
import { initAuth } from './authConfig';

const instrumentationOptions = {
  propagateTraceHeaderCorsUrls: [new RegExp('https://organizerlifekitindnew-bxgmf5cvc0cjgcdm.indiasouthcentral-01.azurewebsites.net/*')], // This is a list of specific URIs or regular exprressions
};
// Telemetry is production-only: the TracingInstrumentation adds a traceparent
// header to API requests, which the backend must whitelist for CORS.
if (process.env.NODE_ENV === 'production') {
  initializeFaro({
    url: 'https://faro-collector-prod-ap-south-1.grafana.net/collect/08a5dbafce78544eb5f1dc8ea11163c4',
    app: {
      name: 'Organizer',
      version: '1.0.0',
      environment: 'production',
    },
    instrumentations: [
      ...getWebInstrumentations(),
      new TracingInstrumentation({ instrumentationOptions }),
    ]})
}
  
 // instrumentations: [
    // Mandatory, omits default instrumentations otherwise.
   // ...getWebInstrumentations(),

    // Tracing package to get end-to-end visibility for HTTP requests.
    //new TracingInstrumentation(),

    // React integration for React applications.
    //new ReactIntegration({
      //router: createReactRouterV5Options({
        //history, // the history object used by react-router
        //Route, // Route component imported from react-router package
  //    }),
    //}),
 // ],



// initAuth resolves false while redirecting to B2C; skip rendering in that case.
initAuth().then((canRender) => {
  if (!canRender) return;
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
